import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryImgSliderComponent } from './components/story-img-slider/story-img-slider.component';
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    StoryImgSliderComponent
  ],
  imports: [
    CommonModule,
    NgxGlideModule,
    MatIconModule
  ],
  exports: [
    StoryImgSliderComponent
  ]
})
export class StoryImgSliderModule { }
